import { Box, Button, Heading } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { appRoutes } from '../../../react-router';
import { TLocalesKeys } from '../../../types';
import { biHelpCenter } from '../../../util/bi';
import { SectionComponentProps } from '../types';

export const ChatbotButton: FC<SectionComponentProps> = ({ positionIndex }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openChatbot = useCallback(() => {
    biHelpCenter.logContactUsButtonInteraction(
      t<TLocalesKeys>('home_contact_us'),
      positionIndex,
    );
    navigate(appRoutes.chatbot());
  }, [navigate, positionIndex, t]);

  return (
    <Box
      marginTop="SP6"
      marginBottom="SP2"
      direction="vertical"
      align-items="center"
      gap="SP2"
    >
      <Heading size="small">{t<TLocalesKeys>('home_still_need_help')}</Heading>
      <Button size="small" onClick={openChatbot}>
        {t<TLocalesKeys>('home_contact_us')}
      </Button>
    </Box>
  );
};
